import { Component, Input } from '@angular/core';

/**
 * "Powered by" + logo de i4life, con las letras apareciendo una a una (el mismo que en cocemfe).
 * Es standalone para poder usarlo tanto en el menú (AppModule) como en el login (LoginPageModule).
 */
@Component({
  selector: 'app-powered-by',
  templateUrl: './powered-by.component.html',
  styleUrls: ['./powered-by.component.scss'],
  standalone: true,
})
export class PoweredByComponent {
  @Input() text: string = 'Powered by';
  @Input() logo: boolean = true;

  protected get letters(): string[] {
    return this.text.split('');
  }
}
